import PropTypes from 'prop-types';
import { Flex, Paper, Text } from '@mantine/core';
import styles from './style.module.css';

const LineChartToolTipComponent = (props) => {
  const {
    label,
    payload,
    precision = 2,
    primaryValue,
  } = props;

  const total = payload?.reduce((acc, item) => acc + (Number(item.value) || 0), 0) || 0;
  const formattedTotal = total.toFixed(precision).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return (
    <Paper px="xs" py="0.3rem" className={styles.paper} >
      <Text classNames={{ root: styles.label }} >
        {label} {primaryValue}
      </Text>
      {payload?.map((item) => {
        const { name, value } = item;
        const formattedValue = Number(value).toFixed(precision).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        return (
          <Flex className={styles.identifier_key} key={name} align='center' gap='sm' mb={5} >
            <Text fz="sm">
              {name}: {formattedValue}
            </Text>
          </Flex>
        );
      })}

      <Flex gap="sm">
        <Text fw={600} fz="sm">
          סה"כ: {formattedTotal}
        </Text>
      </Flex>
    </Paper>
  );
};

LineChartToolTipComponent.propTypes = {
  label: PropTypes.string,
  payload: PropTypes.array,
  precision: PropTypes.number,
  primaryValue: PropTypes.string,
};

export default LineChartToolTipComponent;
